const FULL_COURT_LENGTH_FEET = 94;
const COURT_WIDTH_FEET = 50;
export function nbaShotToHalfCourt(xPercent, yPercent, basketSide) {
    const distanceFromBaselinePercent = basketSide === "left" ? xPercent : 100 - xPercent;
    return {
        xFeet: (distanceFromBaselinePercent / 100) * FULL_COURT_LENGTH_FEET,
        yFeet: (yPercent / 100) * COURT_WIDTH_FEET
    };
}
